import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e0fd3930"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "tutorial-modal__text" }
const _hoisted_3 = { class: "tutorial-modal__buttons" }

import { ref } from 'vue';
import { useTutorialShowedPrefs } from '@/stores/preferences';
import { useInternalization } from '@/composables/useInternalization';

import BaseModal from '@/components/modals/BaseModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TutorialModal',
  props: {
    isOpened: { type: Boolean },
    title: {},
    text: {},
    isLast: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useInternalization();

const isClose = ref(false);

function handleSkip() {
  const { set } = useTutorialShowedPrefs();
  set('yes');
  handleClose();
}

function handleNext() {
  if (props.isLast) {
    const { set } = useTutorialShowedPrefs();
    set('yes');
  }
  handleClose(true);
}

function handleClose(isNext?: boolean) {
  isClose.value = true;
  emit('close', isNext);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-opened": props.isOpened,
    "is-mobile-center": "",
    "is-hide-close": "",
    "is-not-close-outside": !isClose.value,
    class: "tutorial-modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", {
        class: "tutorial-modal__title",
        innerHTML: props.title
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(props.text), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "tutorial-modal__button tutorial-modal__button--skip",
          onClick: handleSkip
        }, _toDisplayString(_unref(t)('skip')), 1),
        _createElementVNode("button", {
          type: "button",
          class: "tutorial-modal__button",
          onClick: handleNext
        }, _toDisplayString(props.isLast ? _unref(t)('letsStart') : _unref(t)('next')), 1)
      ])
    ]),
    _: 1
  }, 8, ["is-opened", "is-not-close-outside"]))
}
}

})